import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      <header className="terms-header">
        <div className="terms-header-content">
          <Link to="/" className="back-link">← Back to Home</Link>
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last updated: February 2026</p>
        </div>
      </header>

      <main className="terms-content">
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By downloading, installing, or using KrossIQ desktop software ("Software"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, do not install or use the Software.
          </p>
        </section>

        <section>
          <h2>2. License Grant</h2>
          <p>
            Subject to the terms of this agreement and payment of applicable fees, KrossIQ grants you a non-exclusive, non-transferable license to:
          </p>
          <ul>
            <li>Install and use the Software on a single computer</li>
            <li>Use the Software for your internal business purposes</li>
            <li>Create and export data analysis reports</li>
          </ul>
          <p>
            This license is valid for the duration specified in your subscription or purchase agreement.
          </p>
        </section>

        <section>
          <h2>3. License Restrictions</h2>
          <p>You may NOT:</p>
          <ul>
            <li>Copy, modify, or distribute the Software</li>
            <li>Reverse engineer, decompile, or disassemble the Software</li>
            <li>Rent, lease, lend, or sublicense the Software</li>
            <li>Remove any proprietary notices or labels on the Software</li>
            <li>Use the Software to develop competing products</li>
            <li>Share your license key with unauthorized users</li>
            <li>Use the Software on more machines than permitted by your license</li>
          </ul>
        </section>

        <section>
          <h2>4. License Activation & Validation</h2>
          <p>
            The Software requires online activation and periodic license validation. Your license key is tied to your machine's hardware identifier. If you change your hardware or need to transfer your license, please contact support@krossiq.com.
          </p>
        </section>

        <section>
          <h2>5. Data & Privacy</h2>
          <p>
            KrossIQ processes your data locally on your machine. We do not access, collect, or store your research data on our servers. The Software may collect:
          </p>
          <ul>
            <li>License validation information (license key, machine ID)</li>
            <li>Basic usage analytics (feature usage, crash reports) to improve the Software</li>
            <li>Support requests and communications you initiate</li>
          </ul>
        </section>

        <section>
          <h2>6. Updates & Support</h2>
          <p>
            Your license includes access to software updates and email support for the duration of your subscription. Major version upgrades may require additional purchase.
          </p>
        </section>

        <section>
          <h2>7. Intellectual Property</h2>
          <p>
            The Software, including all code, graphics, logos, and documentation, is owned by KrossIQ and protected by copyright and intellectual property laws. Your license does not grant you any ownership rights.
          </p>
        </section>

        <section>
          <h2>8. Disclaimer of Warranties</h2>
          <p>
            THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. KROSSIQ DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            IN NO EVENT SHALL KROSSIQ BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SOFTWARE. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID FOR THE LICENSE.
          </p>
        </section>

        <section>
          <h2>10. Termination</h2>
          <p>
            This license terminates automatically if you fail to comply with any term of this agreement. Upon termination, you must cease all use of the Software and delete all copies.
          </p>
        </section>

        <section>
          <h2>11. Refund Policy</h2>
          <p>
            We offer a 14-day refund policy from the date of purchase. To request a refund, contact support@krossiq.com with your order details. Refunds are processed within 5-7 business days.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            KrossIQ reserves the right to modify these terms at any time. Continued use of the Software after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2>13. Contact</h2>
          <p>
            For questions about these Terms & Conditions, contact us at:
          </p>
          <p>
            <strong>Email:</strong> support@krossiq.com<br />
            <strong>Website:</strong> <a href="https://krossiq.com">https://krossiq.com</a>
          </p>
        </section>
      </main>

      <footer className="terms-footer">
        <p>&copy; {new Date().getFullYear()} KrossIQ. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Terms;
